import { useRouter } from '@hooks/useRouter';
import { app } from '@packages/app';
import { createMemo } from '@packages/react';
import { useEffect } from 'react';
import { RouterServiceProvider } from './RouterServiceProvider';

export const RegisterRouterService = createMemo(
    () => {
        const router$ = app(RouterServiceProvider);
        const { router } = useRouter();

        useEffect(() => router$.setRouter(router), ['']);

        return null;
    },
    {
        displayName: 'RegisterRouterService',
    },
);
